import React, { FunctionComponent, ReactNode } from 'react';
import { Icon, Label, Message } from 'semantic-ui-react';

type ProofDocumentStatus = 'selected' | 'uploaded' | 'validated';

type Props = {
  name: string;
  status: ProofDocumentStatus;
  children?: ReactNode;
};

export const ProofDocumentCard: FunctionComponent<Props> = ({
  children,
  name,
  status,
}) => {
  return (
    <Message icon>
      <Icon
        name="file alternate outline"
        color={status === 'selected' ? 'grey' : 'black'}
        style={{ fontSize: '32px' }}
      />
      <Message.Content>
        <Message.Header>{name}</Message.Header>
        <div style={{ marginTop: '4px' }}>
          {status === 'selected' && (
            <Label color="grey">Prêt à être ajouté</Label>
          )}
          {status === 'uploaded' && (
            <Label color="orange">En attente de validation</Label>
          )}
          {status === 'validated' && <Label color="green">Validé</Label>}
        </div>
      </Message.Content>
      {children && (
        <div style={{ display: 'flex', gap: '8px' }}>{children}</div>
      )}
    </Message>
  );
};
